export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_REQUIREMENT_HINT = `Mindestens ${PASSWORD_MIN_LENGTH} Zeichen`;
export const PASSWORD_POLICY_MESSAGES = {
    too_short: `Das Passwort ist zu kurz. Es muss mindestens ${PASSWORD_MIN_LENGTH} Zeichen lang sein.`,
    too_long: `Das Passwort ist zu lang. Es darf höchstens ${PASSWORD_MAX_LENGTH} Zeichen lang sein.`,
    too_common: "Dieses Passwort ist zu leicht zu erraten. Eine längere Passphrase aus mehreren Wörtern ist sicherer.",
};
// Terms shorter than this would reject unrelated passwords once suffixes are stripped (e.g. first name "Li").
const MIN_CONTEXT_TERM_LENGTH = 4;
export function checkPasswordPolicy(password, options) {
    const normalized = password.normalize("NFC").trim();
    // Length is counted in code points, not UTF-16 code units, per NIST SP 800-63B.
    const length = [...normalized].length;
    if (length < PASSWORD_MIN_LENGTH) {
        return "too_short";
    }
    if (length > PASSWORD_MAX_LENGTH) {
        return "too_long";
    }
    const terms = new Set((options.contextTerms ?? [])
        .map((term) => term.normalize("NFC").trim().toLowerCase())
        .filter((term) => [...term].length >= MIN_CONTEXT_TERM_LENGTH));
    for (const candidate of getCandidateForms(normalized.toLowerCase())) {
        if (options.blocklist?.has(candidate) || terms.has(candidate)) {
            return "too_common";
        }
    }
    return null;
}
// Weak passwords are usually a known word made "unique" by appending digits/punctuation or repeating
// it, so each stripped-down form must be checked against the blocklist, not just the full string.
// Suffixes are stripped from the repeating unit too, to catch e.g. "fussball2024fussball2024".
function getCandidateForms(password) {
    const candidates = new Set();
    for (const base of [password, smallestRepeatingUnit(password)]) {
        candidates.add(base);
        const withoutPunctuation = base.replace(/[^\p{L}\p{N}]+$/u, "");
        candidates.add(withoutPunctuation);
        candidates.add(withoutPunctuation.replace(/\d+$/, ""));
    }
    candidates.delete("");
    return candidates;
}
function smallestRepeatingUnit(str) {
    const period = (str + str).indexOf(str, 1);
    return period < str.length ? str.slice(0, period) : str;
}
export function buildPasswordContextTerms(context) {
    const terms = new Set(["pentacode"]);
    const add = (term) => {
        const cleaned = term?.trim().toLowerCase();
        if (cleaned && [...cleaned].length >= MIN_CONTEXT_TERM_LENGTH) {
            terms.add(cleaned);
            terms.add(cleaned.replace(/\s+/g, ""));
        }
    };
    add(context.email);
    add(context.email?.split("@")[0]);
    add(context.firstName);
    add(context.lastName);
    add(context.companyName);
    return [...terms];
}
//# sourceMappingURL=password-policy.js.map